export default "__VITE_ASSET__ggf0NLML__"